import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { PasswordInput } from './ui';
import { BookOpenIcon, UserIcon, LockClosedIcon, BuildingOffice2Icon, ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline';
import styles from './Login.module.css';

function Login({ onLogin }) {
  const [schoolSlug, setSchoolSlug] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch('/api/v1/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ school_slug: schoolSlug.trim(), username, password }),
      });
      const data = await response.json();
      if (response.ok) {
        onLogin(data.access_token, {
          ...data.user,
          school_name: data.school_name,
          theme: data.theme,
          features: data.features,
          attendance_mode: data.attendance_mode,
        });
      } else {
        setError(data.error || 'Login failed');
      }
    } catch (err) {
      setError('Network error. Is the backend running?');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.header}>
          <div className={styles.iconWrap}>
            <BookOpenIcon className={styles.icon} />
          </div>
          <h1 className={styles.title}>School Management System</h1>
          <p className={styles.subtitle}>Sign in to your school's portal</p>
        </div>

        {error && <div className={styles.error}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className={styles.field}>
            <label className={styles.label}>School Code</label>
            <div className={styles.inputWrap}>
              <BuildingOffice2Icon className={styles.inputIcon} />
              <input
                type="text"
                value={schoolSlug}
                onChange={(e) => setSchoolSlug(e.target.value)}
                required
                placeholder="e.g. default"
                className={styles.input}
                autoCapitalize="none"
                autoCorrect="off"
              />
            </div>
          </div>

          <div className={styles.field}>
            <label className={styles.label}>Username</label>
            <div className={styles.inputWrap}>
              <UserIcon className={styles.inputIcon} />
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                placeholder="Enter username"
                className={styles.input}
              />
            </div>
          </div>

          <div className={styles.field}>
            <label className={styles.label}>Password</label>
            <div className={styles.inputWrap}>
              <LockClosedIcon className={styles.inputIcon} />
              <PasswordInput
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Enter password"
                className={styles.input}
              />
            </div>
          </div>

          <button type="submit" className={styles.submitBtn} disabled={loading}>
            {loading ? (
              <>
                <span className={styles.spinner} />
                Logging in...
              </>
            ) : (
              <>
                <ArrowRightOnRectangleIcon style={{ width: 18, height: 18 }} />
                Login
              </>
            )}
          </button>
        </form>

        <p className={styles.linkRow}>
          <Link to="/forgot-password" className={styles.link}>Forgot password?</Link>
        </p>

        <p className={styles.footer}>
          Default: <strong>default</strong> / <strong>developer</strong> / <strong>dev123456</strong>
        </p>
      </div>
    </div>
  );
}

export default Login;
